import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { API_BASE_URL } from '../../core/config/api-config';
import { NotificationsPage } from './notifications.models';

/** HTTP client for FiveWORX.Communication.API.Controllers.NotificationsController (Phase 5). */
@Injectable({ providedIn: 'root' })
export class NotificationsApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = inject(API_BASE_URL);

  private get notificationsUrl(): string {
    return `${this.baseUrl}/v1/notifications`;
  }

  getNotifications(page = 1, pageSize = 25): Observable<NotificationsPage> {
    return this.http.get<NotificationsPage>(this.notificationsUrl, { params: { page, pageSize } });
  }

  markRead(notificationId: string): Observable<void> {
    return this.http.post<void>(`${this.notificationsUrl}/${notificationId}/read`, {});
  }

  markAllRead(): Observable<{ markedCount: number }> {
    return this.http.post<{ markedCount: number }>(`${this.notificationsUrl}/read-all`, {});
  }
}
